import * as d3 from 'd3';
import Api from '../Api.js';
import Thinker from "../components/Thinker";

const DonutPieChart = function (options) {
    const container = $(options.container);

    function render() {
        const margin = {top: 10, right: 30, bottom: 30, left: 50},
            width = (container.width() / 2) - margin.left - margin.right,
            height = 300 - margin.top - margin.bottom,
            boxwidth = 100, boxheight = 50;

        const svg = d3.select(options.svg)
            .attr('width', width + margin.left + margin.right)
            .attr('height', height + margin.top + margin.bottom)
            .append('g')
            .attr("transform", `translate(${width / 2},${height / 2})`);

        const centerText = svg.append('text')
            .attr("font-family", "sans-serif")
            .attr("font-size", 48)
            .attr("font-weight", 'bold')
            .attr("text-anchor", "middle")
            .attr('y', 16);

        Api.send(container.data('url')).done(results => {
            Thinker.end($(options.container));
            const spect = d3.schemeRdBu[11].reverse();
            const radius = Math.min(width, height) / 2;
            const pie = d3.pie()
                .value(d => d.value);

            const arc = d3.arc()
                .outerRadius(radius * 0.9)
                .innerRadius(radius * 0.4);

            const piechart = pie(results);

            const legend = d3.select(options.legend)
                .attr('width', width + margin.left + margin.right)
                .attr('height', ((boxheight + margin.top) * results.length) + margin.top + margin.bottom)
                .append('g');

            svg.selectAll('paths')
                .data(piechart)
                .enter()
                .append('path')
                .attr('fill', (d, i) => spect[i])
                .attr('d', arc)
                .on('mouseover', (evt, d) => {
                    centerText.text(d.data.value);
                    // let msg = `<span class='aero-answer-info'>${d.data.label}, was chosen <h5>${d.data.value}</h5> time(s).</span>`;
                    // container.find('.aero-answer-info-box').html(msg)
                })
                .on('mouseout', () => {
                    centerText.text('');
                });
                // add mouseover?

            legend.selectAll('boxes')
                .data(piechart)
                .enter()
                .append('rect')
                .attr('fill', (d, i) => spect[i])
                .attr('width', boxwidth)
                .attr('height', boxheight)
                .attr('x', 0)
                .attr('y', (d, i) => i * (boxheight + margin.top));

            legend.selectAll('textboxes')
                .data(piechart)
                .enter()
                .append('text')
                .attr('x', boxwidth + margin.top)
                .attr('y', (d, i) => (i * (boxheight + margin.top)) + (boxheight / 2) + margin.top / 2)
                .text(d => d.data.label);

            legend.selectAll('textboxes')
                .data(piechart)
                .enter()
                .append('text')
                .attr('fill', 'white')
                .attr("font-family", "sans-serif")
                .attr("font-size", 16)
                .attr("font-weight", 'bold')
                .attr("text-anchor", "middle")
                .attr('x', boxwidth / 2)
                .attr('y', (d, i) => (i * (boxheight + margin.top)) + (boxheight / 2) + margin.top / 2)
                .text(d => d.data.value);
        });
    }

    setTimeout(function () {
        Thinker.begin($(options.container));
        render();
    }, 100);

    function update() {
        $(options.svg).empty();
        Thinker.begin($(options.container));
        setTimeout(function () {
            render();
        }, 500);
    }

    $('body').on('click', '.hamburger a', function () {
        container.trigger('update');
    });

    container.on('update', function () {
        update();
    });
};

export default DonutPieChart;


/*

// Copyright 2021 Observable, Inc.
// Released under the ISC license.
// https://observablehq.com/@d3/pie-chart
function PieChart(data, {
  name = ([x]) => x,  // given d in data, returns the (ordinal) label
  value = ([, y]) => y, // given d in data, returns the (quantitative) value
  title, // given d in data, returns the title text
  width = 640, // outer width, in pixels
  height = 400, // outer height, in pixels
  innerRadius = 150, // inner radius of pie, in pixels (non-zero for donut)
  outerRadius = Math.min(width, height) / 2, // outer radius of pie, in pixels
  labelRadius = (innerRadius * 0.2 + outerRadius * 0.8), // center radius of labels
  format = ",", // a format specifier for values (in the label)
  names, // array of names (the domain of the color scale)
  colors, // array of colors for names
  stroke = innerRadius > 0 ? "none" : "white", // stroke separating widths
  strokeWidth = 1, // width of stroke separating wedges
  strokeLinejoin = "round", // line join of stroke separating wedges
  padAngle = stroke === "none" ? 1 / outerRadius : 0, // angular separation between wedges
} = {}) {
  // Compute values.
  const N = d3.map(data, name);
  const V = d3.map(data, value);
  const I = d3.range(N.length).filter(i => !isNaN(V[i]));

  // Unique the names.
  if (names === undefined) names = N;
  names = new d3.InternSet(names);

  // Chose a default color scheme based on cardinality.
  if (colors === undefined) colors = d3.schemeSpectral[names.size];
  if (colors === undefined) colors = d3.quantize(t => d3.interpolateSpectral(t * 0.8 + 0.1), names.size);

  // Construct scales.
  const color = d3.scaleOrdinal(names, colors);

  // Compute titles.
  if (title === undefined) {
    const formatValue = d3.format(format);
    title = i => `${N[i]}\n${formatValue(V[i])}`;
  } else {
    const O = d3.map(data, d => d);
    const T = title;
    title = i => T(O[i], i, data);
  }

  // Construct arcs.
  const arcs = d3.pie().padAngle(padAngle).sort(null).value(i => V[i])(I);
  const arc = d3.arc().innerRadius(innerRadius).outerRadius(outerRadius);
  const arcLabel = d3.arc().innerRadius(labelRadius).outerRadius(labelRadius);

  const svg = d3.create("svg")
      .attr("width", width)
      .attr("height", height)
      .attr("viewBox", [-width / 2, -height / 2, width, height])
      .attr("style", "max-width: 100%; height: auto; height: intrinsic;");

  svg.append("g")
      .attr("stroke", stroke)
      .attr("stroke-width", strokeWidth)
      .attr("stroke-linejoin", strokeLinejoin)
    .selectAll("path")
    .data(arcs)
    .join("path")
      .attr("fill", d => color(N[d.data]))
      .attr("d", arc)
    .append("title")
      .text(d => title(d.data));

  svg.append("g")
      .attr("font-family", "sans-serif")
      .attr("font-size", 10)
      .attr("text-anchor", "middle")
    .selectAll("text")
    .data(arcs)
    .join("text")
      .attr("transform", d => `translate(${arcLabel.centroid(d)})`)
    .selectAll("tspan")
    .data(d => {
      const lines = `${title(d.data)}`.split(/\n/);
      return (d.endAngle - d.startAngle) > 0.25 ? lines : lines.slice(0, 1);
    })
    .join("tspan")
      .attr("x", 0)
      .attr("y", (_, i) => `${i * 1.1}em`)
      .attr("font-weight", (_, i) => i ? null : "bold")
      .text(d => d);

  return Object.assign(svg.node(), {scales: {color}});
}

*/
